<template>
    <header class="{p:0|96}@xl {h:94;p:0|32}@lg {h:41;p:0|16} flex ai:center jc:space-between fixed top:0 left:0 right:0 border-bottom:1|solid|gray-94 bg:white {mb:0}_ul z:1005">
        <div class="flex ai:center {ml:60}>div+div">
            <div class="{ml:20}@lg">
                <a href=".">
                    <slot name="logo"></slot>
                </a>
            </div>
            <div class="d:none d:block@lg">
                <ul class="
                    flex ai:center mb:0
                    {list-style:none;m:0;font-weight:700;f:16;lh:1.4;p:0}>li
                    {ml:60}>li+li
                    {color:primaryDark}>li>a
                ">
                    <slot name="desktop"></slot>
                </ul>
            </div>
        </div>
        <div class="flex ai:center rel d:none@<lg">
            <ul class="flex ai:center gap:32 {gap:24}@<lg {gap:20}@<sm
                {inline-block;w:24;h:25}>li.link-icon
                {inline-block;w:24;h:25;bg:no-repeat;background-size:100%|100%;bg:center}>li.link-icon>a
                {px:8;color:primary;font:bold}>li.link-text>a
                {inline-flex;w:48;h:48}>li.link-avatar
                {d:none}>li.link-hamburger@lg
                {inline-flex;w:24;h:24;bg:url(image/icon_hamburger.svg);bg:contain;bg:no-repeat;cursor:pointer}>li.link-hamburger@<lg
                {inline-flex;w:48;h:48;ai:center;jc:center;bg:primary;color:white;cursor:pointer;round}>li.link-avatar>button
                {d:none}>li.link-avatar@<lg
                {d:none}>li.link-text@<lg
            ">
                <li class="h:48 r:24 p:12|20 opacity:90 bg:linear-gradient(rgba(255,243,207,1)0%,rgba(253,248,233,1)100%)">
                    <a class="flex font-weight:700 f:16 lh:25.6px color:#AF6D1F" @click.stop="openInvite" href="javascript:void(0)">
                        <span>邀請好友</span>
                    </a>
                </li>
                <li class="link-icon"><a href="" style="background-image:url(image/icon_header_pen.svg)" data-bs-toggle="modal" data-bs-target="#writeMenuModal"></a></li>
                <li class="link-icon"><a href="" style="background-image:url(image/icon_header_search.svg)" @click.prevent.stop="info.show = !info.show"></a></li>
                <login-button :member="simpleName" :path="path"></login-button>
            </ul>
            <div v-show="info.show">
                <div class="abs w:690 right:0 top:100% mt:21 z:$(comment-zindex)">
                    <div class="rel b:1|solid|#EBEBEB bg:white r:16 box-shadow:0|6|14|0|#D3E2F480">
                        <button class="abs right:20 top:20 w:20 h:20 bg:url(image/icon_close_login.svg) p:2 bg:center bg:no-repeat {d:none}@<lg" @click="info.show = false"></button>
                        <div class="p:32|40|0|40">
                            <ul class="
                                flex m:0 p:0
                                {p:16|0;rel;f:bold;cursor:pointer}_.tab
                                {ml:32}_.tab+.tab
                                {color:primary}_.tab.active
                                {content:'';abs;bottom:0;left:0;right:0;h:4;bg:primary;block}_.tab.active::after
                                {left:10;right:10}_.tab.active::after@<lg
                            ">
                                <li class="tab" :class="{ active: info.tab === 1 }" @click="info.tab = 1">課程評價</li>
                                <li class="tab" :class="{ active: info.tab === 2 }" @click="info.tab = 2" v-if="optPart">話題趴特</li>
                            </ul>
                        </div>
                        <div class="p:24|40|16|40" v-if="info.tab === 1">
                            <search-bar @search="info.search()"></search-bar>
                            <div class="flex mt:24 jc:center">
                                <button class="
                                    p:12|16 inline-flex ai:center jc:center gap:12
                                    {content:'';bg:url(image/index/search/icon_dropdown.svg);w:16;h:16}::after
                                    {transform:rotate(180deg)}.open::after
                                " :class="{ open: toggler('advSearchHeader').isOpen() }" @click="toggler('advSearchHeader').toggle()">
                                    <span>進階篩選</span>
                                </button>
                            </div>
                            <div v-show="toggler('advSearchHeader').isOpen()">
                                <div class="p:24|0 overflow-y:auto max-h:calc(100dvh-420px)">
                                    <div class="mb:12 f:16 font-weight:700">學校系所</div>
                                    <search-college-opts></search-college-opts>
                                    <div class="mt:24 mb:12 f:16 font-weight:700">評價類型</div>
                                    <search-post-opts></search-post-opts>
                                </div>
                                <div class="mb:16 bt:1|solid|#EBEBEB"></div>
                                <div class="px:24 flex ai:center jc:space-between">
                                    <button class="btn btn-link p:0! f:14!" @click="info.clean()" type="button">全部清除</button>
                                    <button class="btn btn-primary" @click="info.search()" type="button">確認</button>
                                </div>
                            </div>
                        </div>
                        <div class="p:24|40|16|40" v-if="info.tab === 2">
                            <part-search-bar></part-search-bar>
                            <div class="p:24|32|48|32">
                                <div class="font-weight:bold">熱門搜尋</div>
                                <div class="flex gap:12 flex-wrap:wrap mt:12 {inlin-flex;p:4|8;r:8;bg:#5E64721A;color:#5E6472}>a">
                                    <a :href="`part?keyword=${word}`" :key="idx" v-for="(word, idx) in keywords">{{ word }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <head-marquee :items="marquees" ref="marquee"></head-marquee>

    <div class="d:none@lg" v-show="!global.showTopicEditor">
        <div class="
            fixed bg:white w:full bottom:0 z:$(comment-zindex)
            border-top:1|solid|#EBEBEB
            flex ai:center jc:space-between h:66
            p:0|32
            {p:0|128}@sm
            {inline-flex;flex-direction:column;ai:center;gap:2;w:48;color:#333;cursor:pointer;f:12;white-space:nowrap}>div
            {color:primary}>div:hover
            {fill:primary}>div:hover_path
        ">
            <div @click="openMenuPanel">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.11133 7.75C5.11133 7.05859 5.66992 6.5 6.36133 6.5H21.3613C22.0527 6.5 22.6113 7.05859 22.6113 7.75C22.6113 8.44141 22.0527 9 21.3613 9H6.36133C5.66992 9 5.11133 8.44141 5.11133 7.75ZM5.11133 14C5.11133 13.3086 5.66992 12.75 6.36133 12.75H21.3613C22.0527 12.75 22.6113 13.3086 22.6113 14C22.6113 14.6914 22.0527 15.25 21.3613 15.25H6.36133C5.66992 15.25 5.11133 14.6914 5.11133 14ZM22.6113 20.25C22.6113 20.9414 22.0527 21.5 21.3613 21.5H6.36133C5.66992 21.5 5.11133 20.9414 5.11133 20.25C5.11133 19.5586 5.66992 19 6.36133 19H21.3613C22.0527 19 22.6113 19.5586 22.6113 20.25Z" fill="#333333" />
                </svg>
                <div>選單</div>
            </div>
            <div @click.stop="openInvite">
                <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.8062 4C15.4976 4 16.0562 4.55859 16.0562 5.25V6.64453C16.1187 6.65234 16.1773 6.66016 16.2398 6.67188C16.2554 6.67578 16.2671 6.67578 16.2828 6.67969L18.1578 7.02344C18.8375 7.14844 19.2867 7.80078 19.1617 8.47656C19.0367 9.15234 18.3843 9.60547 17.7086 9.48047L15.8531 9.14062C14.6304 8.96094 13.5523 9.08203 12.7945 9.38281C12.0367 9.68359 11.732 10.0977 11.6617 10.4805C11.5836 10.8984 11.6421 11.1328 11.7086 11.2773C11.7789 11.4297 11.9234 11.6016 12.2086 11.793C12.8453 12.2109 13.8218 12.4844 15.0875 12.8203L15.2007 12.8516C16.3179 13.1484 17.6851 13.5078 18.7007 14.1719C19.2554 14.5352 19.7789 15.0273 20.1031 15.7148C20.4351 16.4141 20.5054 17.1953 20.3531 18.0273C20.0836 19.5117 19.0601 20.5039 17.7906 21.0234C17.2554 21.2422 16.6734 21.3828 16.0562 21.4531V22.75C16.0562 23.4414 15.4976 24 14.8062 24C14.1148 24 13.5562 23.4414 13.5562 22.75V21.3867C13.5406 21.3828 13.5211 21.3828 13.5054 21.3789H13.4976C12.5445 21.2305 10.9781 20.8203 9.9234 20.3516C9.29449 20.0703 9.00933 19.332 9.29058 18.7031C9.57183 18.0742 10.3101 17.7891 10.939 18.0703C11.7554 18.4336 13.0992 18.793 13.8765 18.9141C15.1226 19.0977 16.15 18.9922 16.8453 18.707C17.5054 18.4375 17.8062 18.0469 17.8921 17.5781C17.9664 17.1641 17.9078 16.9258 17.8414 16.7812C17.7671 16.625 17.6226 16.4531 17.3336 16.2617C16.6929 15.8438 15.7125 15.5703 14.4429 15.2344L14.3336 15.207C13.2203 14.9102 11.8531 14.5469 10.8375 13.8828C10.2828 13.5195 9.76324 13.0234 9.43902 12.3359C9.1109 11.6367 9.04449 10.8555 9.20074 10.0234C9.48199 8.53125 10.5992 7.5625 11.8687 7.05859C12.3882 6.85156 12.9586 6.71094 13.5562 6.62891V5.25C13.5562 4.55859 14.1148 4 14.8062 4Z" fill="#333333" />
                </svg>
                <div>邀請好友</div>
            </div>
            <div @click.stop="openWriteMenuPanel">
                <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.592 5.24634C17.8021 5.24634 18.0036 5.3298 18.1521 5.47837L22.5153 9.84158C22.8247 10.151 22.8247 10.6525 22.5153 10.9619L11.5539 21.9233C11.5539 21.9233 11.554 21.9233 11.5539 21.9233C11.2399 22.2373 10.8141 22.4136 10.3703 22.4136H6.37228C5.93476 22.4136 5.58008 22.0589 5.58008 21.6214V17.6233C5.58008 17.1795 5.75639 16.7537 6.07034 16.4398L17.0318 5.47837C17.1804 5.3298 17.3819 5.24634 17.592 5.24634ZM15.0987 9.65214L7.19063 17.5602C7.17396 17.5769 7.16447 17.5996 7.16447 17.6233V20.8292H10.3703C10.3941 20.8292 10.4168 20.8198 10.4334 20.8031L18.3416 12.895L15.0987 9.65214ZM19.4619 11.7746L20.8348 10.4017L17.592 7.15888L16.2191 8.5318L19.4619 11.7746Z" fill="#333333" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6954 5.14225C16.9331 4.90454 17.2555 4.771 17.5917 4.771C17.9279 4.771 18.2503 4.90454 18.488 5.14225L22.8511 9.50546C23.3461 10.0005 23.3461 10.803 22.8511 11.298L11.8898 22.2593C11.8898 22.2593 11.8898 22.2593 11.8898 22.2593C11.4866 22.6625 10.9399 22.8889 10.3701 22.8889H6.37201C5.67198 22.8889 5.10449 22.3214 5.10449 21.6214V17.6233C5.10449 17.0535 5.33086 16.5068 5.73397 16.1037C5.73396 16.1037 5.73398 16.1037 5.73397 16.1037L16.6954 5.14225ZM11.2176 21.5872C11.2174 21.5873 11.2177 21.587 11.2176 21.5872L22.1789 10.6258C22.3027 10.502 22.3027 10.3014 22.1789 10.1777L17.8158 5.81445C17.7563 5.75502 17.6757 5.72163 17.5917 5.72163C17.5077 5.72163 17.4271 5.75502 17.3676 5.81445L6.40617 16.7759C6.18141 17.0006 6.05513 17.3055 6.05513 17.6233V21.6214C6.05513 21.7964 6.197 21.9382 6.37201 21.9382H10.3701C10.6876 21.9382 10.9928 21.8118 11.2176 21.5872ZM17.5917 6.68354C17.7178 6.68354 17.8387 6.73362 17.9278 6.82276L21.1706 10.0656C21.3563 10.2512 21.3563 10.5522 21.1706 10.7378L19.7977 12.1107C19.6121 12.2963 19.3111 12.2963 19.1255 12.1107L15.8827 8.86788C15.6971 8.68225 15.6971 8.3813 15.8827 8.19568L17.2556 6.82276C17.3447 6.73362 17.4656 6.68354 17.5917 6.68354ZM17.5917 7.83106L16.891 8.53177L19.4616 11.1024L20.1623 10.4017L17.5917 7.83106ZM14.7624 9.31601C14.948 9.13039 15.2489 9.13039 15.4346 9.31601L18.6774 12.5588C18.863 12.7445 18.863 13.0454 18.6774 13.2311L10.7693 21.1391C10.7693 21.1392 10.7693 21.1391 10.7693 21.1391C10.6635 21.245 10.5199 21.3045 10.3701 21.3045H7.16421C6.9017 21.3045 6.68889 21.0917 6.68889 20.8292V17.6233C6.68889 17.4732 6.74869 17.3296 6.85426 17.2241C6.85425 17.2241 6.85426 17.2241 6.85426 17.2241L14.7624 9.31601ZM7.63953 17.7832L15.0985 10.3243L17.6691 12.8949L10.2102 20.3539H7.63953V17.7832Z" fill="#333333" />
                </svg>
                <div>填寫</div>
            </div>
            <div @click.stop="info.show = !info.show">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2419_24925)">
                        <path d="M23.7266 21.293L19.832 17.3984C19.6562 17.2227 19.418 17.125 19.168 17.125H18.5312C19.6094 15.7461 20.25 14.0117 20.25 12.125C20.25 7.63672 16.6133 4 12.125 4C7.63672 4 4 7.63672 4 12.125C4 16.6133 7.63672 20.25 12.125 20.25C14.0117 20.25 15.7461 19.6094 17.125 18.5312V19.168C17.125 19.418 17.2227 19.6562 17.3984 19.832L21.293 23.7266C21.6602 24.0938 22.2539 24.0938 22.6172 23.7266L23.7227 22.6211C24.0898 22.2539 24.0898 21.6602 23.7266 21.293ZM12.125 17.125C9.36328 17.125 7.125 14.8906 7.125 12.125C7.125 9.36328 9.35937 7.125 12.125 7.125C14.8867 7.125 17.125 9.35938 17.125 12.125C17.125 14.8867 14.8906 17.125 12.125 17.125Z" fill="#333333" />
                    </g>
                    <defs>
                        <clipPath id="clip0_2419_24925">
                            <rect width="20" height="20" fill="white" transform="translate(4 4)" />
                        </clipPath>
                    </defs>
                </svg>
                <div>搜尋</div>
            </div>
        </div>
    </div>

    <Teleport to="body">
        <div class="modal fade z:1006!" id="writeMenuModal" tabindex="-1">
            <div class="modal-dialog abs! mt:85! right:60 {right:125}@xl">
                <div class="modal-content p:16 box-shadow:0|0|20|0|black/.4 {abs;content:'';w:50;h:6;bg:url(image/arrow_comment.svg);top:-6;right:95}::before">
                    <div class="
                        modal-body p:0!
                        {p:0;m:0;w:200}_ul
                        {w:full;d:inline-block;h:56;r:20;p:12|32}_li
                        {bg:rgba(94,100,114,0.05)}_li:hover
                        {flex;gap:16;font-weight:700;f:16;lh:32px;color:gray01;ai:center}_li>a
                    ">
                        <ul>
                            <li>
                                <a href="course">
                                    <span>新增課程評價</span>
                                </a>
                            </li>
                            <li v-if="optPart">
                                <a @click="openTopicEditor" data-bs-dismiss="modal" href="javascript:void(0)">
                                    <span>新增話題</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="d:none@lg">
            <func-panel label="填寫" ref="writeMenuPanel">
                <template v-slot:body>
                    <div class="
                        p:24|32 flex:1 overflow-y:auto
                        {p:0;m:0}>ul
                        {w:full;d:inline-block;r:22;p:1}>ul>li
                        {bg:linear-gradient(290.86deg,rgba(248,195,233,0.99)|0%,#C1DDFF|25.49%,#CAE3F3|78.2%,#EFE8AC|100.77%)}>ul>li:hover
                        {flex;gap:16;font-weight:700;f:16;lh:32px;color:gray01;ai:center;p:10|30;w:full;h:56;r:20}>ul>li>a
                        {bg:white!;rel;z:1;color:primary}>ul>li:hover>a
                        {bg:linear-gradient(290.86deg,rgba(248,195,233,0.1485)|0%,rgba(193,221,255,0.15)|25.49%,rgba(202,227,243,0.15)|78.2%,rgba(239,232,172,0.15)|100.77%);content:'';top:0;left:0;h:100%;w:100%;abs;r:20;z:-1}>ul>li:hover>a::after
                    ">
                        <ul>
                            <li>
                                <a href="course">
                                    <span>新增課程評價</span>
                                </a>
                            </li>
                            <li v-if="optPart">
                                <a @click="openTopicEditor" href="javascript:void(0)">
                                    <span>新增話題</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </template>
            </func-panel>
        </div>

        <div class="d:none@lg">
            <func-panel label="搜尋" ref="searchPanel" @hidden="info.show = false">
                <template v-slot:body>
                    <div class="p:0|26|0|26">
                        <ul class="
                            flex m:0 p:0
                            {p:16|0;rel;f:bold;cursor:pointer}_.tab
                            {ml:32}_.tab+.tab
                            {color:primary}_.tab.active
                            {content:'';abs;bottom:0;left:0;right:0;h:4;bg:primary;block}_.tab.active::after
                            {left:10;right:10}_.tab.active::after@<lg
                        ">
                            <li class="tab" :class="{ active: info.tab === 1 }" @click="info.tab = 1">課程評價</li>
                            <li class="tab" :class="{ active: info.tab === 2 }" @click="info.tab = 2" v-if="optPart">話題趴特</li>
                        </ul>
                    </div>
                    <div class="p:16 overflow-y:auto" v-if="info.tab === 1">
                        <search-bar @search="info.search()"></search-bar>
                        <div class="p:24|0|0|0">
                            <div class="mb:12 f:16 font-weight:700" v-if="result">學校系所</div>
                            <search-college-opts class="mb:24"></search-college-opts>
                            <div class="mt:24 mb:12 f:16 font-weight:700" v-if="result">評價類型</div>
                            <search-post-opts></search-post-opts>
                            <template v-if="result">
                                <div class="mt:24 mb:12 f:16 font-weight:700">文章類型</div>
                                <div>
                                    <div class="
                                        flex gap:12 flex-wrap:nowrap {flex-wrap:wrap}@<sm
                                        {p:0|32;flex:1;r:20;inline-flex;ai:center;jc:flex-start;h:56}>button
                                        {w:full;flex:auto}>button@<sm
                                        {bg:#5E64720D}>button.active
                                    ">
                                        <button :class="{ active: info.type === 0 }" @click="info.type = 0">全部文章</button>
                                        <button :class="{ active: info.type === 1 }" @click="info.type = 1">課程評價</button>
                                        <button :class="{ active: info.type === 2 }" @click="info.type = 2">考古題</button>
                                    </div>
                                </div>
                                <div class="mt:24 mb:12 f:16 font-weight:700">時間排序</div>
                                <div>
                                    <div class="
                                        flex gap:12 flex-wrap:nowrap {flex-wrap:wrap}@<sm
                                        {p:0|32;flex:1;r:20;inline-flex;ai:center;jc:flex-start;h:56}>button
                                        {w:full;flex:auto}>button@<sm
                                        {bg:#5E64720D}>button.active
                                    ">
                                        <button :class="{ active: info.sortBy === 'modify_time' }" @click="info.sortBy = 'modify_time'">上傳時間</button>
                                        <button :class="{ active: info.sortBy === 'title' }" @click="info.sortBy = 'title'">課程年度</button>
                                    </div>
                                </div>
                                <div class="mt:24 mb:12 f:16 font-weight:700">新舊排序</div>
                                <div>
                                    <div class="
                                        flex gap:12 flex-wrap:nowrap {flex-wrap:wrap}@<sm
                                        {p:0|32;flex:1;r:20;inline-flex;ai:center;jc:flex-start;h:56}>button
                                        {w:full;flex:auto}>button@<sm
                                        {bg:#5E64720D}>button.active
                                    ">
                                        <button :class="{ active: info.sortDirection === '-' }" @click="info.sortDirection = '-'">由新到舊</button>
                                        <button :class="{ active: info.sortDirection === '+' }" @click="info.sortDirection = '+'">由舊到新</button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="p:16 overflow-y:auto" v-if="info.tab === 2">
                        <part-search-bar :popup="false"></part-search-bar>
                        <div class="p:28|16" v-if="info.part.keywords.length">
                            <div class="font-weight:bold">相關結果</div>
                            <div class="
                                mt:12
                                {flex;ai:center;gap:8;p:14|16;bb:1|solid|#EBEBEB;cursor:pointer}_.history-item
                                {bg:#F8F8F8}_.history-item:hover
                                {flex:1;lh:1.5}_.item-label
                                {mt:12}_.history-item+.history-item
                            ">
                                <div class="history-item" @click="search(item)" :key="item" v-for="(item) in info.part.keywords">
                                    <div class="item-label">{{ item }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="p:28|16" v-else>
                            <div class="font-weight:bold">熱門搜尋</div>
                            <div class="flex gap:12 flex-wrap:wrap mt:12 {inlin-flex;p:4|8;r:8;bg:#5E64721A;color:#5E6472}>a">
                                <a :href="`part?keyword=${word}`" :key="idx" v-for="(word, idx) in keywords">{{ word }}</a>
                            </div>
                            <template v-if="info.part.searched?.length">
                                <div class="flex jc:space-between ai:center mt:24">
                                    <div class="font-weight:bold">我搜尋過的</div>
                                    <button class="p:8|12 f:14 color:#5E6472 font:bold" @click="info.removePartSearchLog(partId)">清除紀錄</button>
                                </div>
                                <div class="
                                    mt:12
                                    {flex;ai:center;gap:8;p:14|16;bb:1|solid|#EBEBEB;cursor:pointer}_.history-item
                                    {bg:#F8F8F8}_.history-item:hover
                                    {mt:12}_.history-item+.history-item
                                    {flex:1;lh:1.5}_.item-label
                                    {inline-flex;w:32;h:32;bg:url(image/part/icon_delete.svg);background-repeat:no-repeat;background-position:center|center}_.btn-remove
                                ">
                                    <div class="history-item" @click="search(item)" :key="item" v-for="(item) in info.part.searched.slice(-10).reverse()">
                                        <div class="item-label">{{ item }}</div>
                                        <button class="btn-remove" @click.stop="info.removePartSearchLog(partId, item)"></button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="bt:1|solid|#EBEBEB"></div>
                    <div class="p:16|24 flex ai:center jc:space-between">
                        <button class="btn btn-link p:0! f:14!" @click="info.clean()" type="button">全部清除</button>
                        <button class="btn btn-primary" @click="info.search()" type="button">確認</button>
                    </div>
                </template>
            </func-panel>
        </div>

        <div class="d:none@lg">
            <func-panel label="所有服務" ref="menuPanel">
                <template v-slot:body>
                    <div class="
                        p:24|32 flex:1 overflow-y:auto
                        {p:0;m:0}>ul
                        {w:full;d:inline-block;r:22;p:1}>ul>li
                        {bg:linear-gradient(290.86deg,rgba(248,195,233,0.99)|0%,#C1DDFF|25.49%,#CAE3F3|78.2%,#EFE8AC|100.77%)}>ul>li:hover
                        {flex;gap:16;font-weight:700;f:16;lh:32px;color:gray01;ai:center;p:10|30;w:full;h:56;r:20}>ul>li>a
                        {bg:white!;rel;z:1;color:primary}>ul>li:hover>a
                        {bg:linear-gradient(290.86deg,rgba(248,195,233,0.1485)|0%,rgba(193,221,255,0.15)|25.49%,rgba(202,227,243,0.15)|78.2%,rgba(239,232,172,0.15)|100.77%);content:'';top:0;left:0;h:100%;w:100%;abs;r:20;z:-1}>ul>li:hover>a::after
                    ">
                        <ul v-if="member">
                            <li class="
                                h:auto! mb:16 cursor:text!
                                {cursor:text!}>a
                                {background-image:none!;}:hover
                                {color:gray01!}:hover>a
                                {d:none!}:hover>a::after
                            ">
                                <a class="ml:-12" @click.prevent>
                                    <button class="{inline-flex;w:48;h:48;ai:center;jc:center;bg:primary;color:white;cursor:pointer;round}"><span v-text="simpleName"></span></button>
                                    <span v-text="member"></span>
                                </a>
                            </li>
                            <li class="collapsed {transform:rotate(180deg)}:where(.collapsed)>a>i:last-child" data-bs-toggle="collapse" data-bs-target="#collapseFooterProfile" v-if="classicMember">
                                <a href="javascript:void(0)">
                                    <i class="fa-regular fa-user w:20 text:center"></i>
                                    <span>個人檔案</span>
                                    <i class="fa-solid fa-angle-up ml:auto"></i>
                                </a>
                            </li>
                            <li v-else>
                                <a href="profile">
                                    <i class="fa-regular fa-user w:20 text:center"></i>
                                    <span>個人檔案</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="collapse" id="collapseFooterProfile" v-if="member && classicMember">
                            <li>
                                <a href="profile">
                                    <i class="w:20 text:center"></i>
                                    <span>會員資料</span>
                                </a>
                            </li>
                            <li>
                                <a href="resume">
                                    <i class="w:20 text:center"></i>
                                    <span>歐趴簡歷</span>
                                </a>
                            </li>
                        </ul>
                        <ul v-if="member">
                            <li class="collapsed {transform:rotate(180deg)}:where(.collapsed)>a>i:last-child" data-bs-toggle="collapse" data-bs-target="#collapseFooterPost">
                                <a href="javascript:void(0)">
                                    <i class="fa-regular fa-rectangle-list w:20 text:center"></i>
                                    <span>課程評價</span>
                                    <i class="fa-solid fa-angle-up ml:auto"></i>
                                </a>
                            </li>
                        </ul>
                        <ul class="collapse" id="collapseFooterPost" v-if="member">
                            <li>
                                <a href="post-list">
                                    <i class="w:20 text:center"></i>
                                    <span>我的上傳紀錄</span>
                                </a>
                            </li>
                            <li>
                                <a href="favorite">
                                    <i class="w:20 text:center"></i>
                                    <span>我的收藏</span>
                                </a>
                            </li>
                        </ul>
                        <ul v-if="member && optPart">
                            <li class="collapsed {transform:rotate(180deg)}:where(.collapsed)>a>i:last-child" data-bs-toggle="collapse" data-bs-target="#collapseFooterTopic">
                                <a href="javascript:void(0)">
                                    <i class="fa-regular fa-comment-dots w:20 text:center"></i>
                                    <span>話題趴特</span>
                                    <i class="fa-solid fa-angle-up ml:auto"></i>
                                </a>
                            </li>
                        </ul>
                        <ul class="collapse" id="collapseFooterTopic" v-if="member && optPart">
                            <li>
                                <a href="topic-list">
                                    <i class="w:20 text:center"></i>
                                    <span>我的上傳紀錄</span>
                                </a>
                            </li>
                            <li>
                                <a href="favorite-topic">
                                    <i class="w:20 text:center"></i>
                                    <span>我的收藏</span>
                                </a>
                            </li>
                        </ul>
                        <ul v-if="member">
                            <li>
                                <a href="invitation">
                                    <i class="fa-solid fa-dollar-sign w:20 text:center"></i>
                                    <span>邀請好友紀錄</span>
                                </a>
                            </li>
                            <li>
                                <a href="request-payment">
                                    <i class="fa-solid fa-hand-holding-dollar w:20 text:center"></i>
                                    <span>我要請領</span>
                                </a>
                            </li>
                            <li>
                                <a href="activity">
                                    <i class="fa-regular fa-circle-check w:20 text:center"></i>
                                    <span>兌換歐趴糖</span>
                                </a>
                            </li>
                        </ul>
                        <hr class="m:12|32 bb:1|solid|#E7ECF4" v-if="member">
                        <ul>
                            <slot name="mobile"></slot>
                            <li class="logout-btn" v-if="member">
                                <a href="javascript:void(0)" @click="openLogoutConfirm">
                                    <i class="fa-solid fa-arrow-right-from-bracket color:#FF6D60"></i>
                                    <span class="color:#FF6D60">登出</span>
                                </a>
                            </li>
                            <li class="login-btn" v-else>
                                <a href="login">登入</a>
                            </li>
                        </ul>
                    </div>
                </template>
            </func-panel>
        </div>

        <alert-modal :no-button="true" ref="inviteModal">
            <div class="font-weight:700">
                邀請好友賺50，提醒他點擊連結後要登入喔！
            </div>
            <div class="flex flex-direction:column gap:12 p:16|24 w:518@sm w:full@<sm r:20 b:3|solid|#FFFFFF bg:#EDF5FF ai:center jc:center m:24|auto">
                <span class="font-weight:400 f:18 lh:28.8px color:#454953 white-space:nowrap lines:1 mx:24 w:full overflow-x:hidden" v-text="inviteUrl"></span>
                <button class="ml:10 {min-w:160;r:100 shadow:0|6|15|rgba(255,109,96,0) btn btn-primary" @click.stop="copyUrl">複製連結</button>
            </div>
            <div class="f:24 {f:28;font-weight:700;color:#538BD4}>span">
            </div>
            <div class="f:16 font-weight:normal mt:16 color:gray02"></div>
        </alert-modal>

        <confirm-modal ref="hLogoutModal" :buttons="{ cancel: '取消', confirm: '確認' }" @confirm="logout" backdrop="static">
            <div class="font-weight:700">
                請問您是否要登出
                <br>
                OPT歐趴糖？
            </div>
        </confirm-modal>

        <confirm-modal ref="hPreventModal" :buttons="{ cancel: '離開', confirm: '繼續寫' }" @cancel="logout" backdrop="static">提醒您！<br>離開此頁面已寫內容將不儲存</confirm-modal>
    </Teleport>
</template>

<script setup>
    const global = useGlobal();
    const info = useSearchInfo();
    const toggleStore = ToggleStore();
    const unloadPreventer = UnloadPreventStore();

    const classicMember = inject("classicMember");
    const optPart = inject("optPart");

    const props = defineProps({
        inviteUrl: { type: String },
        marquees: { default: [], type: Array },
        keywords: { default: [], type: Array },
        member: { default: "", type: String },
        path: { type: String },
        result: { default: false, type: Boolean },
        simpleName: { default: "", type: String }
    });

    const hLogoutModal = ref();
    const hPreventModal = ref();
    const inviteModal = ref();
    const marquee = ref();
    const menuPanel = ref();
    const searchPanel = ref();
    const writeMenuPanel = ref();

    const copyUrl = () => {
        navigator.clipboard.writeText(props.inviteUrl).then(() => {
            open(null);
            window.notifier.info({ message: `已複製連結：${props.inviteUrl}` });
        });
    };

    const logout = () => {
        if (unloadPreventer.isOn()) {
            unloadPreventer.off();
        }
        api("api/member/logout", {}).always(() => {
            if (["evaluation", "exam"].indexOf(props.path) >= 0) {
                window.location.href = "course";
            } else {
                window.location.reload();
            }
        });
    }

    const open = (target) => {
        if (target !== "search") {
            info.show = false;
        }
        if (target === inviteModal) {
            inviteModal.value.show();
        } else {
            inviteModal.value.hide();
        }
        if (target === menuPanel) {
            menuPanel.value.show();
        } else {
            menuPanel.value.hide();
        }
        if (target === writeMenuPanel) {
            writeMenuPanel.value.show();
        } else {
            writeMenuPanel.value.hide();
        }
        if (target === hLogoutModal) {
            hLogoutModal.value.show();
        } else {
            hLogoutModal.value.hide();
        }
        if (target === hPreventModal) {
            hPreventModal.value.show();
        } else {
            hPreventModal.value.hide();
        }
    };

    const openInvite = () => {
        if (props.inviteUrl) {
            open(inviteModal.value?.isOpen() ? null : inviteModal);
        } else {
            window.location.href = "login";
        }
    };

    const openLogoutConfirm = () => {
        open(unloadPreventer.isOn() ? hPreventModal : hLogoutModal);
    }

    const openMenuPanel = () => {
        open(menuPanel.value?.isOpen() ? null : menuPanel);
    };

    const openWriteMenuPanel = () => {
        open(writeMenuPanel.value?.isOpen() ? null : writeMenuPanel);
    };

    const openTopicEditor = () => {
        open(null);
        global.openTopicEditor();
    };

    const search = (keyword) => {
        info.searchPart(null, keyword);
    }

    const toggler = (name) => {
        return toggleStore.toggler(name);
    };

    onMounted(() => {
        document.querySelector("#writeMenuModal")?.addEventListener("show.bs.modal", (e) => {
            info.show = false;
            $(document.querySelector("body")).addClass("{z:1004!}_.modal-backdrop");
        });
        document.querySelector("#writeMenuModal")?.addEventListener("hidden.bs.modal", (e) => {
            $(document.querySelector("body")).removeClass("{z:1004!}_.modal-backdrop");
        });
    });

    watch(() => info.show, () => {
        if (info.show) {
            open("search");
            searchPanel.value.show();
        } else {
            searchPanel.value.hide();
        }
    });

    watch(() => info.invite, openInvite);

    watch(marquee, () => {
        if (localStorage["CloseHeadMarquee"] !== new Date().toLocaleDateString() && props.marquees?.length) {
            marquee.value.show();
        }
    });
</script>
